import { Component } from '@angular/core';
import { SidebarUiService } from '../sidebar-ui.service';
import { LanguageService } from '../../language.service';

// Legacy sidebar chrome (fixed <aside class="l-sidebar">, logo, docpanel); the page nav is projected via <ng-content>.
@Component({
  selector: 'app-old-sidebar',
  templateUrl: './old-sidebar.component.html',
  styleUrls: ['./old-sidebar.component.scss'],
  standalone: false,
})
export class OldSidebarComponent {
  constructor(
    public ui: SidebarUiService,
    private languageService: LanguageService
  ) {}

  get dir(): 'rtl' | 'ltr' {
    return this.languageService.pageDirection();
  }
}
